import { useEffect, useState } from 'react';
import { Form } from 'antd';

export const useWatchForm = ({ form }: { form: any }) => {
  const [isValid, setIsValid] = useState(false);
  const formValues = Form.useWatch([], form);

  useEffect(() => {
    form.validateFields({ validateOnly: true }).then(
      () => setIsValid(true),
      () => setIsValid(false),
    );
  }, [form, formValues]);

  return {
    isValid,
    form,
    formValues,
  };
};
